/* This is just a static page to display when no conversation is selected. */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tinode } from 'tinode-sdk';

import { APP_NAME } from '../config.js';

export default class LogoView extends React.PureComponent {
  render() {
    const version = APP_NAME + ' (' + Tinode.getLibrary() + ')';
    return (
      <div id="dummy-view">
        <div>
          <a href="https://payam.mahs.ir">
            <img id="logo" alt="logo" src="img/logo.svg" />
            <h2>MahsPayam</h2>
          </a>
          <p> سامانه پیام رسان مجتمع آموزشی حضرت سیدالشهدا (ع)</p>
          <a href="./MahsPayam-latest.apk">
            دریافت نسحه ویژه گوشی های هوشمند اندروید
          </a>
        </div>
      </div>
    );
  }
};
